import React from "react";
import classnames from "classnames";
import { View } from "@instructure/ui-view";
import { useStateValue } from "../../context-store/AppStateProvider";
import styles from "./PageWrapper.module.scss";

const IasPageWrapper = ({ children }) => {
  const [{ isAppLoading }] = useStateValue();
  return (
    !isAppLoading && (
      <View
        as="div"
        className={classnames(styles.PageWrapper)}
        background={"primary"}
        padding="large"
      >
        {children}
      </View>
    )
  );
};

export default IasPageWrapper;
